import { formatFullDateAndTime } from "../helpers/timeHelper";

export default class Option {
  constructor(data) {
    let item = data;

    if (item) {
      this.idOption = item.idOption;
      this.name = item.name;
      this.synopsis = item.synopsis;
      this.validFrom = item.validFrom;
      this.validTo = item.validTo;
      this.priceWithoutVat = item.priceWithoutVat;
      this.priceWithVat = item.priceWithVat;
      this.vatRate = item.vatRate;
      this.vatAmount = item.vatAmount;
      this.recurrenceUnit = item.priceDetail.recurrenceUnit;
      this.recurrencePeriod = item.priceDetail.recurrencePeriod;
      this.isUnique = item.isPerPersonUnique;
      this.type = item.type;
      this.objects = item.objectIds;
      this.visible = item.visible;
      this.externalId = item.externalId;
    }
  }

  getIdOption() {
    return this.idOption;
  }

  getName() {
    return this.name;
  }

  getSynopsis() {
    return this.synopsis;
  }

  getValidFrom() {
    return this.validFrom;
  }

  getValidTo() {
    return this.validTo;
  }

  getFormattedValidFrom() {
    return formatFullDateAndTime(new Date(this.validFrom * 1000));
  }

  getFormattedValidTo() {
    return formatFullDateAndTime(new Date(this.validTo * 1000));
  }

  getPriceWithoutVat() {
    return this.priceWithoutVat;
  }

  getPriceWithVat() {
    return this.priceWithVat;
  }

  getVatRate() {
    return this.vatRate;
  }

  getVatAmount() {
    return this.vatAmount;
  }

  getRecurrenceUnit() {
    return this.recurrenceUnit;
  }

  getRecurrencePeriod() {
    return this.recurrencePeriod;
  }

  getIsUnique() {
    return this.isUnique;
  }

  getType() {
    return this.type;
  }

  getLinkObjects() {
    return this.objects;
  }
}
